module.exports = __webpack_public_path__ + "static/image/main/card/image-15.ver2_0_2.png?6af9208a";